import { Body, Button, Col, Grid, GridSettings, H1, Row, Separator } from 'atomic'
import { MatchMedia } from 'atomic/legacy/obj.match-media'
import { graphql } from 'gatsby'
import React from 'react'
import { hasWindow } from 'utils/browser'
import LargeSeparatorRow from 'atomic/atm.large-separator-row/large-separator-row.component'
import SvgErro404 from 'atomic/atm.svg-icon/erro404.component'
import IndexLayout from '../components/org.layout/layout.component'
import { CosmicjsInformacoesEstaticas } from '../data/graphql/graphql-types'
import { PageProps } from '../utils/local-types'
import { pagesPaths } from 'utils/path'
import { isDoctorUrl } from 'utils/url'
import Helmet from 'react-helmet'

interface INotFoundPageProps {}

const NotFoundPage: React.FunctionComponent<PageProps<INotFoundPageProps>> = props => {
  const cosmicData: CosmicjsInformacoesEstaticas = props.data.cosmicjsInformacoesEstaticas
  const handleBackClick = () => {
    if (hasWindow()) {
      window.history.back()
    }
    return null
  }
  return (
    <IndexLayout location={props.location}>
      <Helmet>
        <script>{`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-MQ8JW4W');
        `}</script>
      </Helmet>

      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-MQ8JW4W"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="gtm"
        />
      </noscript>
      <Grid>
        <LargeSeparatorRow />

        <Row reverse>
          <Col xs={12} mdOffset={1} md={7}>
            <SvgErro404 width="100%" />
            <MatchMedia defaultMinWidth={`${GridSettings.flexboxgrid.breakpoints.md}em`}>
              {md => md && <Separator />}
            </MatchMedia>
          </Col>

          <Col xs={12} md={4}>
            <Row mb>
              <Col xs={12}>
                <H1>{cosmicData.title}</H1>
                <Body>
                  <Separator />
                  <div dangerouslySetInnerHTML={{ __html: cosmicData.content }} />
                </Body>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Button id="button-back-404" kind="secondary" expanded onClick={handleBackClick}>
                  {cosmicData.metadata.botaoVoltarTexto}
                </Button>
              </Col>
              <Col xs={6}>
                <Button
                  id="button-404"
                  kind="secondary"
                  expanded
                  to={
                    isDoctorUrl(props.location.pathname)
                      ? pagesPaths.homeDoctor.path
                      : pagesPaths.homeClient.path
                  }
                >
                  {cosmicData.metadata.botaoPaginaInicialTexto}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <LargeSeparatorRow />
      </Grid>
    </IndexLayout>
  )
}

export default NotFoundPage

export const query = graphql`
  query PaginaNaoEncontrada {
    cosmicjsInformacoesEstaticas(slug: { eq: "pagina-nao-encontrada" }) {
      title
      content
      metadata {
        botaoVoltarTexto
        botaoPaginaInicialTexto
      }
    }
  }
`
